import DOMPurify from "dompurify";

export function sanitizeTicketHtml(html: string): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_DATA_URI_TAGS: ["img"],
    ADD_ATTR: ["target", "rel"],
  });
}
